var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39524 0.187205L19.8352 0.17216C24.3686 0.166677 26.9583 2.72355 26.9638 7.27021L26.9789 19.7235C26.9843 24.2435 24.4141 26.8333 19.8808 26.8388L7.42749 26.8539C2.88082 26.8593 0.317698 24.2758 0.312231 19.7558L0.29717 7.30246C0.29167 2.7558 2.84857 0.192705 7.39524 0.187205ZM14.7327 14.6183L18.5194 14.6138C19.1327 14.5997 19.6254 14.1058 19.6247 13.4924C19.6239 12.8791 19.13 12.3864 18.5167 12.3871L14.73 12.3917L14.7255 8.63168C14.7247 8.01835 14.2308 7.52561 13.6174 7.52635C13.0041 7.52709 12.5114 8.02102 12.5121 8.63436L12.5167 12.3944L8.74334 12.3989C8.45001 12.3993 8.17015 12.5196 7.95706 12.7199C7.75732 12.9334 7.63766 13.2123 7.63801 13.5069C7.63875 14.1203 8.13268 14.613 8.74603 14.6256L12.5194 14.621L12.5239 18.3943C12.5247 19.0077 13.0186 19.5004 13.6319 19.4997C14.2453 19.4989 14.738 19.005 14.7373 18.3917L14.7327 14.6183Z",
    fill: "#3E64F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.88c0bcf71f6aafcff9ac2cda6f72459b.svg";
export { ForwardRef as ReactComponent };